/* Copy the displayed permalink with truthful, accessible completion feedback. */
if (!customElements.get('share-button')) {
  customElements.define('share-button', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.input = this.querySelector('input');
      this.details = this.querySelector('details');
      this.status = this.querySelector('[role="status"]');
      const copy = this.querySelector('.share-button__copy');
      const close = this.querySelector('.share-button__close');
      if (!this.input || !this.details || !this.status || !copy) return;
      this.bound = true;
      this.input.setAttribute('aria-label', this.input.getAttribute('placeholder') || 'Link');
      const reset = () => {
        this.status.textContent = '';
        this.status.classList.add('hidden');
        this.removeAttribute('data-copy-failed');
        if (close) close.classList.add('hidden');
      };
      this.details.addEventListener('toggle', () => { if (!this.details.open) reset(); });
      copy.type = 'button';
      copy.addEventListener('click', async () => {
        copy.disabled = true;
        this.removeAttribute('data-copy-failed');
        this.status.textContent = '';
        this.status.classList.remove('hidden');
        try {
          if (!navigator.clipboard || !navigator.clipboard.writeText) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(this.input.value);
          if (!this.details.open) return;
          this.status.textContent = 'Link copied.';
          if (close) { close.classList.remove('hidden'); close.focus(); }
        } catch (error) {
          if (!this.details.open) return;
          this.setAttribute('data-copy-failed', '');
          this.status.textContent = 'Copy was not permitted. Select the link and copy it manually.';
          if (close) close.classList.remove('hidden');
          this.input.focus();
          this.input.select();
        } finally {
          copy.disabled = false;
        }
      });
      if (close) {
        close.type = 'button';
        close.addEventListener('click', () => {
          reset();
          this.details.open = false;
          this.querySelector('summary').focus();
        });
      }
    }
  });
}
